import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ff-menu-bar',
  templateUrl: './menu-bar.component.html'
})
export class MenuBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/manuel/Sites/doxasoft/fenyofarm/csemete/src/app/menu-bar/menu-bar.component.ts